import { FeatureName } from '@common/enums/feature-name.enum';

export const pathsByFeatureName = {
  [FeatureName.LiveChat]: '/specialist/live-chat',
  [FeatureName.VideoChat]: '/specialist/calls',
};
